var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hang-tags',{attrs:{"msg":"Etiquetas"}})
}
var staticRenderFns = []

export { render, staticRenderFns }